import React from "react";

import Messages from "../messages";

class SearchResultsFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.message || false,
      loader: false,
    };
  }

  render() {
    if (!this.state.message) {
      return <span />; // pas de false pour contourner un bug avec react 0.13 et IE8
    }

    const text = Messages.searchFeedback[this.state.message];

    let loader;
    if (this.state.loader) {
      loader = (
        <span
          className="icon-loader no-mobile"
          data-icon="&#xe602;"
          aria-hidden
        />
      );
    }

    return (
      <p className="search-feedback">
        <span>{text}</span>
        {loader}
      </p>
    );
  }
}
export default SearchResultsFeedback;
